<template>
    <GnzsSection 
        :disabled="!tariffFeatures.includes('partial-realization')"
        :disabledText="disabledProSectionText" 
        header='Частичная реализация'>
        <template v-slot:description>
            Если включено, то в модальном окне детализации заказа добавится блок для проведения частичной реализации.
        </template>
        <template v-slot:header-control>
            <GnzsSwitcher
                v-model="defaults.isPartialRealizationEnabled"
            ></GnzsSwitcher>
        </template>
        <div v-if="defaults.isPartialRealizationEnabled" :class="w.table">
            <div :class="w.tableRow">
                <div>После проведения реализации</div>
                <div>
                    <GnzsDropdown 
                        :class="w.w200"
                        v-model="actionCloseAferSaveRealization" 
                        :items="actionsCloseAferSaveOrder"
                        :use-empty-item="false"
                    ></GnzsDropdown>
                </div>
            </div>
        </div>
    </GnzsSection>
</template>

<script>
import { mapGetters } from "vuex";

import GnzsSection from "@/gnzs-controls/Section";
import GnzsSwitcher from "@/gnzs-controls/Switcher";
import GnzsDropdown from '@/gnzs-controls/Dropdown';

// функция для создания методов вычисляемого поля, которое может работать с директивой v-model
const mapFieldModel = function(fieldName){
    return {
        get(){
            return this.$store.getters['settings/defaults'][fieldName];
        },
        set(value){
            this.$store.dispatch('settings/setDefaultsField', {field: fieldName, value});
        }
    }
}

export default {
    computed: {
        ...mapGetters({
            defaults: "settings/defaults",
            tariffFeatures: 'features/getFeatures',
            disabledProSectionText: 'localSettings/disabledProSectionText',
            actionsCloseAferSaveOrder: 'localSettings/actionsCloseAferSaveOrder',
        }),
        actionCloseAferSaveRealization: { ...mapFieldModel.call(this, 'actionCloseAferSaveRealization') },
    },
    components: {
        GnzsSection,
        GnzsSwitcher,
        GnzsDropdown
    },
};
</script>

<style lang="scss" module="w">
    @import '@/assets/scss/Settings/style.scss';
</style>
